<template>
  <a class="w-full flex my-4" :href="content.url">
    <card-item-image :image="content.image" />
    <div class="ml-4 flex flex-col">
      <span class="text-md leading-normal">{{ content.title }}</span>
      <span class="text-sm leading-none">{{ authors }}</span>
    </div>
  </a>
</template>

<script>
import CardItemImage from '../shared/CardItemImage'
import { toSentence } from 'helpers/array'

export default {
  components: { CardItemImage },
  props: {
    content: {
      type: Object,
      required: true
    }
  },

  computed: {
    authors() {
      if (this.content.authors.length > 1) {
        return toSentence(this.content.authors.map(item => item.name))
      } else {
        return `de ${this.content.authors.map(item => item.name)[0]}`
      }
    }
  }
}
</script>
